import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import caseStudyService from "../../services/caseStudies/caseStudyService";
import sweetAlert from "../../utils/sweetAlert";
import { toast } from "react-toastify";

import "./CaseStudies.css";

export default function CaseStudyList() {

    const [caseStudies, setCaseStudies] = useState([]);

    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);

    const [pageSize] = useState(10);

    const [search, setSearch] = useState("");

    const [totalPages, setTotalPages] = useState(0);


    useEffect(() => {

        loadCaseStudies();

    }, [page, search]);


    const loadCaseStudies = async () => {

        try {

            setLoading(true);

            const response = await caseStudyService.getList(
                page,
                pageSize,
                search
            );

            if (response.success) {

                setCaseStudies(response.data.items);

                setTotalPages(response.data.totalPages);

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };


    const handleDelete = async (id) => {

        const confirmed = await sweetAlert.confirmDelete();

        if (!confirmed) {

            return;

        }

        try {

            const response = await caseStudyService.delete(id);

            if (response.success) {

                toast.success(response.message);

                loadCaseStudies();

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }

    };


    return (

        <AdminLayout>

            <div className="page-header">

                <h2>Case Studies</h2>

                <Link
                    to="/case-studies/add"
                    className="btn btn-primary"
                >
                    Add Case Study
                </Link>

            </div>


            {/* Search */}

            <div className="d-flex mb-3 gap-2">

                <input
                    type="text"
                    className="form-control"
                    placeholder="Search case studies..."
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value);
                        setPage(1);
                    }}
                />

                <button
                    className="btn btn-primary"
                    disabled={loading}
                    onClick={() => setPage(1)}
                >
                    Search
                </button>

            </div>


            {/* Table */}

            <div className="card">

                <div className="card-body">

                    <div className="table-responsive">

                        <table className="table table-bordered align-middle">

                            <thead>

                                <tr>

                                    <th style={{ width: "50px" }}>
                                        #
                                    </th>

                                    <th>
                                        Title
                                    </th>

                                    <th>
                                        Condition
                                    </th>

                                    <th>
                                        Duration
                                    </th>

                                    <th>
                                        Display Order
                                    </th>

                                    <th>
                                        Action
                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                {
                                    loading ?

                                        <tr>

                                            <td
                                                colSpan="6"
                                                className="text-center"
                                            >
                                                Loading...
                                            </td>

                                        </tr>

                                        :

                                        caseStudies.length === 0 ?

                                            <tr>

                                                <td
                                                    colSpan="6"
                                                    className="text-center"
                                                >
                                                    No Case Studies Found
                                                </td>

                                            </tr>

                                            :

                                            caseStudies.map((item, index) => (

                                                <tr key={item.id}>

                                                    <td>
                                                        {(page - 1) * pageSize + index + 1}
                                                    </td>

                                                    <td>
                                                        {item.title}
                                                    </td>

                                                    <td>
                                                        {item.condition || "-"}
                                                    </td>

                                                    <td>
                                                        {item.duration || "-"}
                                                    </td>

                                                    <td>
                                                        {item.displayOrder}
                                                    </td>

                                                    <td>

                                                        <Link
                                                            to={`/case-studies/edit/${item.id}`}
                                                            className="btn btn-warning btn-sm me-2"
                                                        >
                                                            Edit
                                                        </Link>

                                                        <button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() =>
                                                                handleDelete(item.id)
                                                            }
                                                        >
                                                            Delete
                                                        </button>

                                                    </td>

                                                </tr>

                                            ))

                                }

                            </tbody>

                        </table>

                    </div>


                    {/* Pagination */}

                    {
                        totalPages > 1 && (

                            <div className="d-flex justify-content-end mt-3">

                                <nav>

                                    <ul className="pagination mb-0">

                                        <li
                                            className={`page-item ${
                                                page === 1
                                                    ? "disabled"
                                                    : ""
                                            }`}
                                        >

                                            <button
                                                className="page-link"
                                                onClick={() =>
                                                    setPage(page - 1)
                                                }
                                                disabled={page === 1}
                                            >
                                                Previous
                                            </button>

                                        </li>


                                        {
                                            Array.from(
                                                { length: totalPages },
                                                (_, index) => index + 1
                                            ).map(pageNumber => (

                                                <li
                                                    key={pageNumber}
                                                    className={`page-item ${
                                                        page === pageNumber
                                                            ? "active"
                                                            : ""
                                                    }`}
                                                >

                                                    <button
                                                        className="page-link"
                                                        onClick={() =>
                                                            setPage(pageNumber)
                                                        }
                                                    >
                                                        {pageNumber}
                                                    </button>

                                                </li>

                                            ))
                                        }


                                        <li
                                            className={`page-item ${
                                                page === totalPages
                                                    ? "disabled"
                                                    : ""
                                            }`}
                                        >

                                            <button
                                                className="page-link"
                                                onClick={() =>
                                                    setPage(page + 1)
                                                }
                                                disabled={page === totalPages}
                                            >
                                                Next
                                            </button>

                                        </li>

                                    </ul>

                                </nav>

                            </div>

                        )
                    }

                </div>

            </div>

        </AdminLayout>

    );

}